<template>
    <div>



        <div class="container-fluid stepsBar">
            <div class="row justify-content-center">
                <div class="col-md-6">

                    <br>
                    <br>
                    <br>
                    <br>
                    <div class="text-center loginRegSection">
                        <h2 class="mb-4 textGreen">Sign in</h2>
                        <p>Login below to access your account</p>
                        

                        <form class="userFormWrpr text-left mx-auto my-5 vld-parent" @submit.prevent="login()" ref="frm_login" autocomplete="off" v-if="!user">
                            <label class="inputWrpr">
                                <input type="email" class="form-control" :class="{ 'is-invalid': errors.email }"
                                    id="exampleInputemail" v-model="details.email" />
                                <div class="invalid-feedback" v-if="errors.email">
                                    {{ errors.email[0] }}
                                </div>
                                <span class="label">Email Address</span>
                            </label>
                            <label class="inputWrpr mb-3">
                                <input type="password" class="form-control" :class="{ 'is-invalid': errors.password }"
                                    id="exampleInputPassword1" v-model="details.password">
                                <div class="invalid-feedback" v-if="errors.password">
                                    {{ errors.password[0] }}
                                </div>
                                <span class="label">Password</span>

                            </label>

                            <div class="form-group">
                                <input type="checkbox" class="checkbox-custom" id="exampleCheck1"
                                    v-model="wev_remember_me">
                                <label class="checkbox-custom-label" for="exampleCheck1">Remember me</label>
                            </div>

                            <div class="form-group text-center">
                                <router-link to="/reset_password" class="btnForget">Forgot your password?</router-link>
                            </div>

                            <div class="form-group text-center mt-4">
                                <input type="submit" value="Sign In" class="btn btnSubmit">
                                <router-link to="/register" class="btnoutlineWhite">Sign up for free as a homeowner</router-link>
                            </div>
                            <div class="form-group text-center mt-4">
                            <router-link
                                to="/"
                                type="button"
                                class="btn btn-dark w-100">Continue Shopping
                            </router-link>
                        </div>
                        </form>


                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
                <!-- <div class="col-md-6">
                   
                </div> -->
            </div>
        </div>
 


    </div>


</template>

<script>
 import {
     mapGetters,
     mapActions
 } from "vuex";
 export default {
     name: "Login",
     components: {

     },
     data() {
         return {
            frm_otp:'',
             details: {
                 email: $cookies.isKey('wev_log_email') ? $cookies.get('wev_log_email') : '',
                 password: $cookies.isKey('wev_log_pass') ? $cookies.get('wev_log_pass') : ''
             },
             wev_remember_me: $cookies.isKey('wev_remember_me') ? $cookies.get('wev_remember_me') : '',
             redirect_path: this.$route.query.redirect
         }
     },

     computed: {
         ...mapGetters(["errors"]),
         ...mapGetters("auth", ["user"]),
         ...mapGetters({ 
            showroomId: "Common/MyItem", 
        })
     },

     mounted() {
        var redirect_to = localStorage.getItem('redirect_to');
        if(redirect_to){
            localStorage.removeItem('redirect_to');
            this.redirect_path=redirect_to;
        }
         this.$store.commit("setErrors", {});
         if (this.user) {
             if (this.user.type == 'Admin') {
                 if (this.$cookies.get("otp_verify"))
                     this.$router.push('/account').catch(() => {});
             } else {
                 this.$router.push('/account').catch(() => {});
             }
         }

     },
     watch: {
         user: {
             handler: function (newValue) {
                 if (newValue) {
                     if (this.user && (this.user.status == 'Active' || this.user.status == 'Approve')) {
                         if (this.user.type == 'Admin') {
                             if (this.$cookies.get("otp_verify"))
                                 this.$router.push('/account').catch(() => {});
                         } else {
                             this.$router.push("/account").catch(() => {});
                         }
                     }
                 }
             },
             deep: true
         }
     },
     methods: {
         ...mapActions("auth", ["sendLoginRequest", "sendSocialLoginRequest" ,"sendLogoutRequest"]),
         ...mapActions("cart", ["projectCreatRequest","addBulkCartRequest","addCartRequest","addProjectToCartRequest"]),


        verify_otp(n = '') {
            if (n) {
                let loaderL = this.$loading.show({
                    container: this.$refs.frm_login,
                });
                axios.get('/api/login/verify_otp')
                    .then(res => {
                        Toast.fire({
                            icon: "success",
                            title: res.data.message,
                        });
                        loaderL.hide()
                    })
                    .catch(err => {
                        loaderL.hide()
                    });
            } else {
                this.$validator.validateAll('frmVerifyOtp').then(async (valid) => {
                    if (valid) {
                        let loaderL = this.$loading.show({
                            container: this.$refs.frm_login,
                        });
                        axios.get('/api/login/verify_otp', {
                                params: {
                                    otp: this.frm_otp
                                }
                            })
                            .then(res => {
                                if (res.data.data && res.data.data.valid_otp) {
                                    this.$cookies.set("otp_verify", true, "340d")
                                    window.location.reload();
                                }
                                Toast.fire({
                                    icon: "success",
                                    title: res.data.message,
                                });
                                loaderL.hide()
                            })
                            .catch(err => {
                                loaderL.hide()
                            });

                    }
                })
            }
        },

         login: function () {
             let loaderL = this.$loading.show({
                 container: this.$refs.frm_login,
             });
             this.sendLoginRequest(this.details).then(() => {
                     loaderL.hide()
                     if (this.wev_remember_me) {
                         this.$cookies.set("wev_log_email", this.details.email, "340d")
                         this.$cookies.set("wev_log_pass", this.details.password, "340d")
                         this.$cookies.set("wev_remember_me", true, "340d")
                     }
                        this.$cookies.remove("otp_verify");
                     if (localStorage.getItem("authToken")) {
                         //this.getUserData();
                         if (!this.user) {
                             this.sendLogoutRequest();
                         } else {
                            if (this.user.type != 'User') {
                                Toast.fire({
                                    icon: 'error',
                                    title: 'You are not authorized to access this page.'
                                });
                                this.sendLogoutRequest();
                            }else{

                            let temp_project_id=localStorage.getItem('cart_id');

                            if(temp_project_id){

                                var retrievedItem = JSON.parse(localStorage.getItem('my_item'));
                                let is_3d = retrievedItem.is_3d
                                let showroom = retrievedItem.showroom
                                let cart_item={};
                                cart_item.re_temp_project_id=temp_project_id;
                                // if (!is_3d) {
                                    this.projectCreatRequest(retrievedItem).then((res) => {
                                        console.log("res",res);
                                        var project = parseInt(localStorage.getItem('project'));
                                        console.log("project==========>",project);
                                        if(project){
                                            cart_item.project_id = project
                                        }else{
                                            cart_item.project_id =res;
                                        }
                                        let items = []
                                        this.addProjectToCartRequest(cart_item).then(() => {

                                            localStorage.removeItem('cart_id');
                                            loaderL.hide();
                                            var redirect_to = localStorage.getItem('redirect_to');
                                            if(redirect_to){
                                                localStorage.removeItem('redirect_to');
                                                this.$router.push(redirect_to).catch(() => {});
                                            }
                                            this.$router.push(this.redirect_path || '/').catch(() => {});

                                    })
                                    .catch(() => {
                                        loaderL.hide();
                                    })


                                        })
                                        .catch(err => {
                                            Toast.fire({
                                                icon: 'error',
                                                title: 'Please login to proceed.'
                                            });
                                        });
                                // }



                            }
                            console.log("herrrrrr");
                             if (this.user.status == 'Active' || this.user.status == 'Approve') {
                                 this.$cookies.set("wev_ut", this.user.type, "1d");
                                 if (!this.user.email_verified_at) {
                                     this.$router.push("/verifiction").catch(() => {});
                                 } else {

                                     if (this.user.type != 'User') {
                                        if(this.user.type == 'Admin'){
                                            if(this.$cookies.get("otp_verify"))
                                         this.$router.push('/account').catch(() => {});
                                        }else{
                                         this.$router.push('/account').catch(() => {});
                                        }
                                     } else {



                                        let visual_redirect = localStorage.getItem('visual_redirect');
                                        if(this.user.type == 'User' && visual_redirect){

                                        var retrievedItem = JSON.parse(localStorage.getItem('my_item'));
                                        if (retrievedItem && retrievedItem.showroom && retrievedItem.floorplan && retrievedItem.floorTemplate) {
                                        var project = localStorage.getItem('project');
                                        if(typeof(project) == 'undefined' || project=='undefined' || project==null || project=='null'){
                                            project=''
                                        }
                                        retrievedItem.project=project
                                        this.projectCreatRequest(retrievedItem).then(() => {
                                            localStorage.removeItem("visual_redirect");
                                            this.$router.push(visual_redirect || '/').catch(() => {});
                                        })
                                        .catch(err=>{
                                            Toast.fire({
                                                icon: 'error',
                                                title: 'Internal server error.'
                                            });
                                            this.$router.push('/').catch(() => {});
                                        });
                                        }else{
                                            this.$router.push('/').catch(() => {});
                                        }

                                            return
                                        }

                                         if (this.user.type == 'User' && this.redirect_path == '/visualize/checklist') {
                                             this.$router.push(this.redirect_path || '/').catch(() => {});
                                             return
                                         }

                                         if (this.user.type == 'User' && this.user.total_projects > 0) {
                                             this.$router.push('/').catch(() => {});
                                         } else {
                                             if (this.redirect_path == '/login') {
                                                 this.$router.push('/').catch(() => {});
                                             } else {
                                                 this.$router.push(this.redirect_path || '/').catch(() => {});
                                             }
                                         }
                                     }
                                 }
                             } else {
                                 let sts = this.user.status;
                                 this.sendLogoutRequest();
                                 if (sts == 'Deactive') {
                                     Toast.fire({
                                         icon: 'error',
                                         title: 'Your account has been deactivated. Please contact WeVisu Support.'
                                     });
                                 } else {
                                     Toast.fire({
                                         icon: 'error',
                                         title: 'Your account is currently pending approval by Wevisu.'
                                     });
                                 }
                             }
                            }
                         }
                     }

                 })
                 .catch(err => {
                     loaderL.hide()
                 });

         },

         AuthProvider(provider) {
             this.$Progress.start()
             var self = this

             this.$auth.authenticate(provider).then(response => {

                 self.SocialLogin(provider, response)

             }).catch(err => {
                 this.$Progress.fail()
             })

         },

         SocialLogin(provider, response) {
             const req = {
                 provider: provider,
                 data: response
             };
             let loader = this.$loading.show({
                 container: this.$refs.frm_login,
             });
             this.sendSocialLoginRequest(req).then(() => {
                 loader.hide()
                 if (localStorage.getItem("authToken")) {
                     //this.getUserData();
                     if (!this.user) {
                         this.sendLogoutRequest();
                     } else {
                         if (this.user.type == 'User' && this.user.total_projects > 0) {
                             this.$router.push('/projects').catch(() => {});
                         } else {
                             if (this.redirect_path == '/login') {
                                 this.$router.push('/').catch(() => {});
                             } else {
                                 this.$router.push(this.redirect_path || '/').catch(() => {});
                             }
                         }
                     }
                 }
             }).catch(err => {
                 loader.hide()
             })

             /*   this.$http.post('/api/sociallogin/' + provider, response).then(response => {


                this.$Progress.finish()
             }).catch(err => {
                 this.$Progress.fail()
             })  */
         },





     }

 }

</script>

<style scoped>
.ttl{
    font-size: 25px !important;
}
</style>
